exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na[data-v-4596736a]:hover {\n  cursor: pointer;\n}\n.product-info[data-v-4596736a] {\n  background-color: #fff;\n  margin-top: 15px;\n  padding: 10px;\n  width: 100%;\n}\n.product-info table[data-v-4596736a] {\n  width: 100%;\n}\n.product-info table td[data-v-4596736a],\n.product-info table th[data-v-4596736a] {\n  vertical-align: top;\n}\n.product-info.error[data-v-4596736a] {\n  background-color: #dc3545;\n  color: #fff;\n}\n.module-title[data-v-4596736a] {\n  background-color: #17a2b8;\n  color: #fff;\n  font-size: 20px;\n  line-height: 40px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4596736a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ProductionItemInfo.vue
// module id = HCfX
// module chunks = 1